export default __webpack_public_path__ + "static/Economic Model Update - Polish-ab69732dad93049b009bdfccb3fb31c7.pdf";